
import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"
const colors: Object = {
    'yellow': '#A78BFA',
    'violet': '#4C1D95',
    'darkgray': '#586174',
    'lightgray': '#A29CA5',
    'gray': '#EDE9FE',
    'white': '#FFFFFF'
}
const validatorColors = function(value: string) {
    return value in colors;
};
@Component
export default class IconButtonComponent extends Vue {
    @Prop({required: true}) icon: string;
    @Prop({validator: validatorColors, default: 'darkgray'}) fill: string;
    @Prop({validator: validatorColors, default: 'gray'}) color: string;
    @Prop({default: ''}) tooltip: string;
    get hrefIcon(): string {
        return `/assets/img/svg-sprite.svg#${this.icon}`
    }
    get tooltipText(): string {
        if (this.tooltip) {
            return this.tooltip;
        }

        switch (this.icon) {
            case 'edit-icon':
                return 'Редактировать';
            case 'delete-icon':
                return 'Удалить';
            case 'eye-icon':
                return 'Просмотреть';
            default:
                return '';
        }
    }
    get iconClass(): string {
        return `icon-button-${this.icon}`;
    }
    getHtmlColor(color: string): string {
        return (colors as any)[color];
    }
}
